import { toPng } from 'html-to-image';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

type Vfs = { [file: string]: string };
const pm = pdfMake as typeof pdfMake & { vfs?: Vfs };
const fonts = pdfFonts as unknown as { pdfMake?: { vfs?: Vfs }; vfs?: Vfs };
if (!pm.vfs) { const v = fonts?.pdfMake?.vfs ?? fonts?.vfs; if (v) pm.vfs = v; }

/** Letter page: 612 × 792 pt. Each node is captured as one full page, so nothing gets shrunk. */
const PAGE_W = 612;
const PAGE_H = 792;
const MARGIN = 24;

export async function exportPagesToPdf(nodes: HTMLElement[], filename: string) {
  const images: string[] = [];
  for (const node of nodes) {
    images.push(await toPng(node, { pixelRatio: 2, cacheBust: true, skipFonts: true, backgroundColor: '#ffffff' }));
  }
  const w = PAGE_W - MARGIN * 2;
  const h = PAGE_H - MARGIN * 2;
  const content = images.map((image, i) => ({ image, fit: [w, h] as [number, number], alignment: 'center' as const, ...(i > 0 ? { pageBreak: 'before' as const } : {}) }));
  pdfMake.createPdf({ pageSize: 'LETTER', pageMargins: [MARGIN, MARGIN, MARGIN, MARGIN], content, info: { title: filename } }).download(filename);
}

/** Each node becomes one full page of the given size in points (e.g. a 5 × 7 in card = 360 × 504), no margins. */
export async function exportCardsToPdf(nodes: HTMLElement[], filename: string, widthPt: number, heightPt: number) {
  const images: string[] = [];
  for (const node of nodes) images.push(await toPng(node, { pixelRatio: 4, cacheBust: true, skipFonts: true, backgroundColor: '#ffffff' }));
  const content = images.map((image, i) => ({ image, width: widthPt, height: heightPt, ...(i > 0 ? { pageBreak: 'before' as const } : {}) }));
  pdfMake.createPdf({ pageSize: { width: widthPt, height: heightPt }, pageMargins: [0, 0, 0, 0], content, info: { title: filename } }).download(filename);
}
